// extracted by mini-css-extract-plugin
module.exports = {"divider--left":"jgp-2b7YX","divider--right":"jgp-1G-0_","jg-qrwrapper--ticket":"jgp-2JytW","qr-header":"jgp-1EhPj"};